module.exports = __webpack_public_path__ + "static/media/31JFA4.b0ca3466.jpg";